const errMsgList = {
  accountLogout: '您的账号已被注销'
}

export default errMsgList
